import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CloseIcon } from '../icons';
import './modals.css';
import React from 'react';
const Modal = ({ onClose, children }) => (_jsx("div", { className: 'modal-backdrop', onClick: onClose, children: _jsxs("div", { className: 'modal-card', onClick: (e) => e.stopPropagation(), children: [_jsx("button", { className: 'modal-close', title: 'Close', onClick: onClose, children: _jsx(CloseIcon, {}) }), children] }) }));
export default React.memo(Modal);
